export default __webpack_public_path__ + "static/media/m_ceoLanding01.41af32ee.png";